module.exports = __webpack_public_path__ + "static/AuthorBioPageHero60@2x.e79d21b7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/AuthorBioPageHero60@2x.jpg
// module id = 660
// module chunks = 106182774615790